import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CouponProfile {
  barcode?: string;
  cardNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  shopperid?: number;
  accountid?: number;
}

interface UserState {
  couponProfile: CouponProfile | null;
  setCouponProfile: (profile: CouponProfile | null) => void;
  updateCouponProfile: (updates: Partial<CouponProfile>) => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      couponProfile: null,

      setCouponProfile: (profile) => set({ couponProfile: profile }),

      updateCouponProfile: (updates) =>
        set((state) => ({
          couponProfile: state.couponProfile
            ? { ...state.couponProfile, ...updates }
            : updates,
        })),
    }),
    {
      name: 'user-storage',
    }
  )
);
